export enum Actions {
  INCREMENT = 'INCREMENT',
  ORDERSTATE = 'ORDERSTATE',
  MAINSTATE = 'MAINSTATE',
  CHANGETEMPPW = 'CHANGETEMPPW',
  USERREGISTERSUCCESS = 'USERREGISTERSUCCESS',
  USERREGISTERFAILURE = 'USERREGISTERFAILURE',
  UPDATESOCIALUSERPROFILE = 'UPDATESOCIALUSERPROFILE',
  DELETESOCIALUSERPROFILE = 'DELETESOCIALUSERPROFILE',
  USERLOGGEDIN = 'USERLOGGEDIN',
  USERTOKENREFRESHED = 'USERTOKENREFRESHED',
  USERLOGGEDOUT = 'USERLOGGEDOUT',
  UPDATEEMAILUSERPROFILE = 'UPDATEEMAILUSERPROFILE',
  UPDATEUSERPROFILE = 'UPDATEUSERPROFILE',
  UPDATEUSERAVATAR = 'UPDATEUSERAVATAR',
  SETLOCATIONSELECTED = 'SETLOCATIONSELECTED',
  CLEARLOATIONSELECTED = 'CLEARLOATIONSELECTED',
  UPDATEORDER = 'UPDATEORDER',
  UPDATEFAVORITE = 'UPDATEFAVORITE',
  CLEARFAVORITE = 'CLEARFAVORITE',
  UPDATELASTORDER = 'UPDATELASTORDER',
  UPDATEPICKUPTYPE = 'UPDATEPICKUPTYPE',
  SUBMITTEDORDER = 'SUBMITTEDORDER',
  CONFIRMANDPAY = 'CONFIRMANDPAY',
  CONFIRMANDPAYORDER = 'CONFIRMANDPAYORDER',
  GUESTLOGIN = 'GUESTLOGIN',
  ORDERPAYMENTINFO = 'ORDERPAYMENTINFO',
  ORDERGUESTPAYMENTINFO = 'ORDERGUESTPAYMENTINFO',
  CLEARORDER = 'CLEARORDER',
  VISITINFO = 'VISITINFO',
  CONTACTUS = 'CONTACTUS',
  FRANCHISE = 'FRANCHISE',
  VIRTUALGIFTCARD = 'VIRTUALGIFTCARD',
  SUBMITTEDGIFTCARDORDER = 'SUBMITTEDGIFTCARDORDER',
  CLEARVIRTUALGIFTCARD = 'CLEARVIRTUALGIFTCARD',
  BRAZEUSER = 'BRAZEUSER',
  CLEARBRAZEUSER = 'CLEARBRAZEUSER',
  NONFOODORDER = 'NONFOODORDER',
  CONTACTUSPROBLEM = 'CONTACTUSPROBLEM',
}

export class Action {
  constructor(public type: string, public data: any) {
  }
}
